export const MOCK_SMTP_RESPONSE = {
  results: [
    {
      id: 'mock-smtp-1',
      host: 'mail.example.com',
      port: 587,
      data: {
        starttls: {
          title: 'STARTTLS',
          status: 'pass',
          detail: 'STARTTLS is supported and enforced.',
          description: 'The server upgrades plain connections to encrypted ones using STARTTLS.',
          data: [],
        },
        tls_version: {
          title: 'TLS Version',
          status: 'pass',
          detail: 'TLS 1.3 and TLS 1.2 supported.',
          description: 'Modern TLS versions are in use. TLS 1.0 and 1.1 are disabled.',
          data: ['TLS 1.3', 'TLS 1.2'],
        },
        banner_grab: {
          title: 'Banner',
          status: 'pass',
          detail: 'Server banner does not expose version information.',
          description: 'The SMTP banner is safe and does not reveal software version.',
          data: ['220 mail.example.com ESMTP'],
        },
        open_relay: {
          title: 'Open Relay',
          status: 'pass',
          detail: 'Server is not an open relay.',
          description: 'The mail server correctly rejects unauthenticated relay attempts.',
          data: [],
        },
      },
    },
    {
      id: 'mock-smtp-2',
      host: 'smtp2.example.com',
      port: 25,
      data: {
        starttls: {
          title: 'STARTTLS',
          status: 'fail',
          detail: 'STARTTLS is not supported.',
          description: 'This server does not support encrypted connections. Upgrade to support STARTTLS.',
          data: [],
        },
        tls_version: {
          title: 'TLS Version',
          status: 'error',
          detail: 'TLS not available.',
          description: 'No TLS encryption is available on this server.',
          data: [],
        },
        open_relay: {
          title: 'Open Relay',
          status: 'fail',
          detail: 'Server accepted unauthenticated relay.',
          description: 'This server is an open relay. Attackers can use it to send spam. Restrict relay to authenticated users immediately.',
          data: [],
        },
      },
    },
  ],
  current_page: 1,
  total_pages: 1,
}
